<template>
  <div>
    <tool-bar :title="title"></tool-bar>

    <loading :loading="loading"></loading>

    <error-alert-item
      :error-alert-event="errorAlertEvent"
      :network-error="networkError"
      @resetErrorAlertEvent="errorAlertEvent=false"
    ></error-alert-item>

    <activity-redirect-item
      :loan-tasks="tasks"
      :current-loan-task="currentTaskName"
      :is-loan-task="true"
      :redirect-activity="redirectActivity"
    ></activity-redirect-item>

    <stage-comment-item></stage-comment-item>

    <div class="margin_top_20">

      <div class="item-heading-desc-div margin-left-20 margin-right-20">
        <weex-text class="item-heading ">Select any of the below banks you have account with
        </weex-text>
      </div>

      <wxc-radio
        class="margin-left-10"
        :list="bankAccounts"
        :config="radioButtonConfig"
        @wxcRadioListChecked="onBankAccountSelected($event.value)"
      ></wxc-radio>

      <wxc-button
        text="Next"
        class="margin_top_20 margin-bottom-20 horizontal_center"
        type="blue"
        @wxcButtonClicked="onSubmit"
      ></wxc-button>
    </div>
  </div>
</template>

<script>
import WxcButton from "../../../weex-ui/packages/wxc-button/index";
import WxcRadio from "../../../weex-ui/packages/wxc-radio/index";
import ToolBar from "../layout/ToolBar";
import ActivityRedirectItem from "../layout/ActivityRedirectItem";
import ErrorAlertItem from "../layout/ErrorAlertItem";
import Loading from "../layout/Loading";
import StageCommentItem from "../layout/StageCommentItem";
import { Activities } from "../../utils/ActivityNavigator";
import DataSource from "../../data/DataSource";
import LoanScopeDataHolder from "../../data/model/LoanScopeDataHolder";
import LoanTasksActivityNavigator from "../../utils/LoanTasksActivityNavigator";
import AlertService from "../core/alert/AlertService";
import { DefaultResourceConfig } from "../../utils/ImageResourcesUtil";
import EzUtils from "../../utils/EzUtils";

const SELECT_OPTION = "Please select an option.";

export default {
  name: "ChooseBankAccountsActivity",
  components: {
    ActivityRedirectItem,
    ToolBar,
    ErrorAlertItem,
    Loading,
    StageCommentItem,
    WxcButton,
    WxcRadio
  },

  data: () => ({
    title: "Choose Bank Accounts",
    loading: false,
    errorAlertEvent: false,
    networkError: {},
    bankAccounts: [],
    bankAccount: ""
  }),

  methods: {
    showToast(message) {
      AlertService.showToast(message);
    },

    showError(error) {
      this.loading = false;
      this.networkError = error ? error : {};
      this.errorAlertEvent = true;
    },

    onBankAccountSelected(bankAccount) {
      this.bankAccount = bankAccount;
    },

    onSubmit() {
      if (this.checkForValidation()) {
        const clientsAccounts = [];
        clientsAccounts.push({ lenderName: this.bankAccount, accountPresent: true });
        DataSource.saveClientAccounts(
          LoanScopeDataHolder.getLoanId(),
          { clientAccountDataList: clientsAccounts }
        )
          .then(clientsAccountsSaveRes => {
            if (clientsAccountsSaveRes.errorOccurred) {
              this.showError(clientsAccountsSaveRes.data);
            } else {
              this.completeCurrentTaskAndGetNextTask();
            }
          })
      }
    },

    checkForValidation() {
      if (!this.bankAccount) {
        this.showToast(SELECT_OPTION);
        return false;
      }

      return true;
    },

    completeCurrentTaskAndGetNextTask() {
      this.loading = true;
      LoanTasksActivityNavigator.getNextTask(this.tasks)
        .then(res => {
          this.loading = false;
          if (res.errorOccurred) {
            this.showError(res.data);
          }
        });
    }
  },

  created() {
    const bankAccounts = this.stageConfigData ? this.stageConfigData.bankAccounts : [];

    this.bankAccounts = [];
    bankAccounts && bankAccounts.forEach(bankAccount => {
      if (bankAccount) {
        this.bankAccounts.push(
          { title: bankAccount.fullName, value: bankAccount.shortName }
        );
      }
    });
  },

  computed: {
    redirectActivity() {
      return Activities.LOAN_DETAILS;
    },

    tasks() {
      return [Activities.CHOOSE_BANK_ACCOUNTS];
    },

    currentTaskName() {
      return LoanScopeDataHolder.getCurrentLoanTask()
        ? LoanScopeDataHolder.getCurrentLoanTask().name
        : "";
    },

    stageConfigData() {
      const currentTask = LoanScopeDataHolder.getCurrentLoanTask();
      const stageConfigDataAsString = currentTask ? currentTask.config_data : null;
      return EzUtils.convertToJSONObjectIfString(stageConfigDataAsString);
    },

    radioButtonConfig() {
      return DefaultResourceConfig.RADIO_BUTTON;
    },
  }
};
</script>

<style scoped src="../../assets/style/base.css"></style>

